import request from "superagent";

import config from "config/config";
import { getTabToken } from "common/MetaActions";
import { CustomerServerSettings } from "models/customers/customers";

export class SettingsAPI {
  static async getSettings(): Promise<CustomerServerSettings> {
    const result = await request
      .get(config.api.settings.settings)
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken());

    return result.body;
  }
}
